import React, { MouseEvent } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import moment from 'moment';
import classNames from 'classnames'
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { updateProductReturnType } from '../../store/actions/mainDashboard';
import { useHistory } from 'react-router-dom';
import { ICard, Legend } from '../../shared/models/mainDashboardModel';
  
interface IProps {
    index:number;
    columnId: string;
    canEdit: boolean;
    canView: boolean;
    card: ICard;
    updateProductReturnType: Function;

}
const Task = (props: IProps) =>  {
    const history = useHistory();
    const {card} = props;
    const viewReturnNote = () => {
        return (
           history.push(`/return-note/${+card.id.split('item_')[1]}`)
        )

    }
    const updateLegend = (e: MouseEvent,legend:number ) => {
        e.stopPropagation();
        if(legend === Legend.notes) {
            return;
        }
        props.canEdit  && props.updateProductReturnType(props.columnId,card.id,legend);
    }
    return (
    <Draggable draggableId={card.id} index={props.index}>
            {(provided, snapshot) => {
                // snapshot.isDragging ?  document.body.classList.add('is-dragging') :  document.body.classList.remove('is-dragging');
                return (<>
                    <div className={classNames("card", "card-kanban", "init-ticket", "box-shaddow", { 'coloured-status': card.productType === 1 || card.productType === 2 || card.timeElapsed })}
                        ref={provided.innerRef}
                        data-is-dragging={snapshot.isDragging}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                            backgroundColor: card.timeElapsed ? card.timeElapsedColor : card.productTypeColor,
                            ...provided.draggableProps.style
                        }}
                        onClick={() => props.canView && viewReturnNote()}>
                        <div className="ticket-top">
                            <h3>{card.name}</h3>
                            <div className="ticket-info">
                                <span className="blue-lable mr-3">SN: {card.serialNo}</span>
                                <span>{moment(card.date).format('Do MMM YYYY')}</span>
                            </div>
                        </div>
                        <div className="ticket-bottom">
                            <ul className="ticket-status">
                                <li className={classNames({ 'active': card.warranty })}>
                                    <a onClick={(e) => updateLegend(e, Legend.warranty)} >W</a>
                                </li>
                                <li className={classNames({ 'active': card.hireUnit })}>
                                    <a onClick={(e) => updateLegend(e, Legend.hireUnit)}>H</a>
                                </li>
                                <li className={classNames({ 'active': card.urgent })}>
                                    <a onClick={(e) => updateLegend(e, Legend.urgent)}>U</a>
                                </li>
                                <li className={classNames({ 'active': card.notes })}>
                                    <a onClick={(e) => updateLegend(e, Legend.notes)}>N</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {snapshot.isDragging && (
                        <div className="init-ticket box-shaddow ">
                            <div className="placeholder"></div>
                        </div>)
                    }
                </>
                )
            }
        }
    </Draggable>
);
}

const mapStateToProps = (state:any) => ({
    
})

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
    updateProductReturnType:  bindActionCreators(updateProductReturnType,dispatch)
});

export default connect(mapStateToProps,mapDispatchToProps)(Task);